
//Dependencies
import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './Components/App';
import history from './history';
// Routes
import AppRoutes from './routes';
		
//Assets
import './index.css';


import registerServiceWorker from './registerServiceWorker';


render(
	<Router history={history}>
		<App/>
	</Router>
	, document.getElementById('root')
);	
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js